import { AfterViewInit, Component, ElementRef, EventEmitter, inject, Input, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { PaymentsService } from 'src/app/services/payments.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import {
  buildPaymentComplementPayload,
  toLocalDateInput,
} from 'src/app/shared/utils/payment-complement.util';
import * as xml2js from 'xml2js';
import { firstValueFrom, timer } from 'rxjs';

interface ComplementPayment {
  id: number;
  sat_code: string;
  description: string;
  show_for_payment_complements: boolean;
}

@Component({
  selector: 'app-modal-options-pay',
  template: `
    <ng-template #modalOptionsPay let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Opciones de pago</h5>
        <button type="button" aria-label="Cerrar" class="btn btn-link text-dark" (click)="dismiss()" [disabled]="loading">
          <fa-icon [icon]="icons.faTimes"></fa-icon>
        </button>
      </div>
      <div class="modal-body p-4">
        <table class="table table-sm border-0" style="font-size: 0.8em;">
          <tbody class="text-dark">
            <tr>
              <td colspan="3" scope="col" class="text-start"><b>Gas</b></td>
            </tr>
            <tr>
              <td class="ps-4 text-secondary">Consumo</td>
              <td colspan="2" scope="col" class="text-end text-secondary">{{bill?.consumo_periodo | currency: 'USD'}}</td>
            </tr>
            <tr>
              <td class="ps-4 text-secondary">Descuento(s)</td>
              <td colspan="2" scope="col" class="text-end text-secondary">-{{bill?.discount | currency: 'USD'}}</td>
            </tr>
            <tr>
              <td class="ps-4">Total consumo</td>
              <td colspan="2" scope="col" class="text-end">{{bill?.consumo_total | currency: 'USD'}}</td>
            </tr>
            <tr class="border-bottom-secondary">
              <td scope="col" class="text-start">Adeudos</td>
              <td colspan="2" scope="col" class="text-end" *ngIf="bill?.interests">{{bill?.interests | currency: 'USD'}}</td>
            </tr>
            <tr class="border-bottom-secondary">
              <td scope="col" class="text-start">Recargos (% Int.)</td>
              <td colspan="2" scope="col" class="text-end" *ngIf="bill?.recargos">{{bill?.recargos | currency: 'USD'}}</td>
            </tr>
            <tr class="border-bottom-secondary">
              <td scope="col" class="text-start">Admon.</td>
              <td colspan="2" scope="col" class="text-end" *ngIf="bill?.admin_price">{{bill?.admin_price | currency: 'USD'}}</td>
            </tr>
          </tbody>
        </table>

        <table class="table table-sm mt-4 border-0" style="font-size: 0.8em;">
          <thead>
            <tr>
              <td class="text-secondary">Subtotal</td>
              <td colspan="2" scope="col" class="text-end text-secondary">{{bill?.sub_total | currency: 'USD'}}</td>
            </tr>
            <tr>
              <td class="text-secondary">IVA</td>
              <td colspan="2" scope="col" class="text-end text-secondary">{{bill?.taxes | currency: 'USD'}}</td>
            </tr>
            <tr class="border-bottom-0">
              <th class="border-bottom-0">Total</th>
              <th colspan="2" scope="col" class="text-end border-bottom-0">{{bill?.total | currency: 'USD'}}</th>              
            </tr>
          </thead>
        </table>

        <form [formGroup]="payForm">
          <div class="form-group text-start mb-3">
            <label for="payment_method_type" class="form-label text-sm">Forma de pago</label>
            <select id="payment_method_type" class="form-select" formControlName="payment_method_type" (change)="updatePaymentDescription()">
              <option [ngValue]="null" disabled>Seleccionar forma de pago</option>
              <option *ngFor="let payment of complementPayments" [ngValue]="payment.id">{{payment.description}}</option>
            </select>
            <div *ngIf="ufc['payment_method_type']?.touched && ufc['payment_method_type']?.errors?.['required']" class="text-danger text-sm">
              La forma de pago es requerida.
            </div>
          </div>
          <div class="form-group text-start">
            <label for="transaction_id" class="form-label text-sm">Folio</label>
            <input type="text" class="form-control" placeholder="Ingresar folio del pago" formControlName="transaction_id">
            <div *ngIf="ufc['transaction_id']?.touched && ufc['transaction_id']?.invalid">
              <div *ngIf="ufc['transaction_id']?.errors?.['required']" class="text-danger text-sm">El folio es requerido.</div>
            </div>
          </div>
          <div class="form-group text-start mt-3">
            <label for="payment_date" class="form-label text-sm">Fecha de pago</label>
            <input type="date" class="form-control" formControlName="payment_date">
          </div>
          <div class="form-group text-start mt-3">
            <label for="amount" class="form-label text-sm">Monto pagado</label>
            <input type="number" min="0.01" step="0.01" class="form-control" placeholder="Ingresar monto del pago" formControlName="amount">
            <div *ngIf="ufc['amount']?.touched && ufc['amount']?.invalid">
              <div *ngIf="ufc['amount']?.errors?.['required']" class="text-danger text-sm">La cantidad es requerida.</div>
              <div *ngIf="ufc['amount']?.errors?.['min']" class="text-danger text-sm">La cantidad debe ser mayor a cero.</div>
            </div>
          </div>
          
        </form>
        <div *ngIf="bill?.invoiced" class="mt-4">

          <div class="form-check form-switch ps-1">
            <input
              class="form-check-input float-end"
              type="checkbox"
              [formControl]="complement"
              (change)="updateComplement($event)"
            >
            <label class="form-check-label" for="flexCheckDefault">
              Generar complemento de pago
            </label>
          </div>

        </div>
      </div>
      <div class="modal-footer pt-4">
        <div class="d-flex flex-fill">
          <div class="text-start">
            <p class="text-sm text-muted">{{loading_msg}}</p>
          </div>
          <div class="ms-auto text-end ms-2">
            <button type="button" 
              class="btn btn-outline-success" 
              (click)="registerPay()" 
              [disabled]="loading"
            >
              <fa-icon [icon]="icons.faSave" *ngIf="!loading" class="me-2"></fa-icon>
              <fa-icon [icon]="icons.faCircleNotch" animation="spin" *ngIf="loading" class="me-2"></fa-icon>
              Registrar pago
            </button>
          </div>
        </div>
      </div>     
    </ng-template>

    <!-- div class="btn-group" role="group" aria-label="Basic radio toggle button group">
              <!- input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked (click)="selectPayMethod('CASH')">
              <label class="btn btn-outline-primary pt-3" for="btnradio1">
                <fa-icon [icon]="icons.faCashRegister"></fa-icon><br>
                <p>Pago en efectivo</p>
              </label ->

              <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off" checked (click)="selectPayMethod('STP')">
              <label class="btn btn-outline-primary pt-3" for="btnradio2">
                <fa-icon [icon]="icons.faCashRegister"></fa-icon><br>
                <p>Pago vía STP</p>
              </label>

              <!- input type="radio" class="btn-check" name="btnradio" id="btnradio3" autocomplete="off" routerLink="/tenant/bill/{{bill.id}}">
              <label class="btn btn-outline-primary pt-3" for="btnradio3">
                <fa-icon [icon]="icons.faCreditCard"></fa-icon><br>
                <p>Tarjeta de crédito</p>
              </label ->
            </div -->
  `,
  styleUrls: []
})
export class ModalOptionsPayComponent implements AfterViewInit {
  private readonly store = inject(SettlementsService);
  private readonly paymentsService = inject(PaymentsService);
  private readonly fb = inject(FormBuilder);
  public readonly icons = inject(IconsService);
  private readonly toastr = inject(ToastrService);
  public readonly modalService = inject(NgbModal);

  @Input() bill: any;
  @Input() profile: any;
  @Output() billData: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild("modalOptionsPay") modalOptionsPay !: ElementRef;

  private modalRef: NgbModalRef | undefined;

  payForm: FormGroup = new FormGroup({});
  complementPayments: ComplementPayment[] = [];
  invoiceComplementForm: FormGroup = new FormGroup({});
  invoiceData: any = {};
  loading: boolean = false;
  loading_msg: string = '';

  complement: FormControl = new FormControl(false);

  parser: any;

  ngAfterViewInit(): void {
    this.initForm();
    this.buildInvoiceComplementForm();
    this.loadComplementPayments();
  }

  loadComplementPayments(): void {
    this.paymentsService.getComplementsPayments().subscribe({
      next: (payments: ComplementPayment[]) => {
        this.complementPayments = payments;
      },
      error: () => {
        this.toastr.error('No fue posible cargar las formas de pago.', 'Error');
      },
    });
  }

  initForm() {
    this.payForm = this.fb.group({
      transaction_id: ['', Validators.required],
      amount: [this.bill?.total, [Validators.required, Validators.min(0.01)]],
      currency: ['MXN', Validators.required],
      status_code: ['3', Validators.required],
      error_code: ['00', Validators.required],
      error_message: ['Approved', Validators.required],
      payment_method_bin: ['0', Validators.required],
      payment_method_type: [null, Validators.required],
      payment_method_brand: ['', Validators.required],
      bill_id: [this.bill?.id, Validators.required],
      payment_date: [toLocalDateInput(), Validators.required],
    });
  }

  updateComplement(event: any) {
    this.complement.setValue(Boolean(event.target.checked), { emitEvent: false });
  }

  buildInvoiceComplementForm() {
    this.invoiceComplementForm = this.fb.group({
      payment_date: [toLocalDateInput(), [Validators.required]]
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['bill'] && changes['bill'].currentValue) {
      if (this.payForm.contains('amount')) {
        this.payForm.patchValue({
          amount: this.bill.total,
          payment_date: toLocalDateInput(),
          bill_id: this.bill.id,
        });
      }
    }
  }

  get ufc() {
    return this.payForm.controls;
  }

  updatePaymentDescription(): void {
    const payment = this.complementPayments.find(
      payment => payment.id === this.payForm.get('payment_method_type')?.value
    );
    this.payForm.get('payment_method_brand')?.setValue(payment?.description ?? '');
  }

  /* selectPayMethod(method: string) {
    this.payForm.patchValue({
      amount: '',
      payment_date: toLocalDateInput(),
      transaction_id: '',
    });
    this.payForm.get('payment_method_type')?.setValue(method);
    this.payForm.get('payment_method_brand')?.setValue(method);
  } */

  async registerPay() {
    if (this.payForm.invalid) {
      this.payForm.markAllAsTouched();
      this.toastr.error('Favor de llenar todos los campos', 'Error');
      return;
    }
    if (Number(this.payForm.value.amount) > Number(this.bill.total)) {
      this.toastr.error('El monto pagado no puede ser mayor al total del recibo.', 'Error');
      return;
    }

    this.loading = true;
    this.loading_msg = 'Registrando pago en ZAZZ...';
    let paymentCreated = false;
    const complementRequested = Boolean(this.complement.value);

    try {
      const transaction = await firstValueFrom(this.store.createTransaction(this.payForm.getRawValue()));
      paymentCreated = true;
      this.billData.emit({
        bill: {
          ...this.bill,
          status: Number(this.payForm.value.amount) >= Number(this.bill.total),
          paid_date: this.payForm.value.payment_date,
        },
        transaction,
      });
      this.loading_msg = 'Actualizando el estado del recibo...';
      const currentBill = this.bill;
      const refreshedBill = await this.refreshBillAfterPayment();
      this.bill = {
        ...currentBill,
        ...refreshedBill,
        invoice_id: refreshedBill?.invoice_id ?? currentBill?.invoice_id,
        unit_id: refreshedBill?.unit_id ?? currentBill?.unit_id,
        due_date: refreshedBill?.due_date ?? currentBill?.due_date,
      };
      this.billData.emit({ bill: this.bill, transaction });
      this.toastr.success('Pago registrado correctamente.', 'Éxito');

      if (complementRequested) {
        this.invoiceComplementForm.patchValue({
          payment_date: toLocalDateInput(this.payForm.value.payment_date),
        });
        await this.createComplement();
        this.toastr.success('Complemento generado correctamente.', 'Éxito');
      }

      this.dismiss();
    } catch (error: any) {
      const detail = this.errorDetail(error);
      if (paymentCreated) {
        if (complementRequested) {
          this.toastr.error(
            `El pago quedó registrado, pero no fue posible generar o finalizar el complemento.${detail}`,
            'Complemento pendiente'
          );
        } else {
          this.toastr.warning(
            `El pago quedó registrado, pero no fue posible confirmar la actualización de la pantalla.${detail}`,
            'Pago registrado'
          );
        }
        this.dismiss();
      } else {
        this.toastr.error(`Ocurrió un error al registrar el pago.${detail}`, 'Error');
      }
    } finally {
      this.loading = false;
      this.loading_msg = '';
    }
  }

  async createComplement(): Promise<void> {
    this.loading_msg = 'Creando complemento de pago...';
    if (this.invoiceComplementForm.invalid) {
      this.invoiceComplementForm.markAllAsTouched();
      throw new Error('Por favor, completa la fecha de pago.');
    }

    const response: any = await firstValueFrom(this.store.getInvoice(this.bill.invoice_id));
    const parsedInvoice = await this.processXML(response.invoice.cfdixml);
    const payload = buildPaymentComplementPayload({
      bill: this.bill,
      invoice: response.invoice,
      profile: this.profile,
      parsedInvoice,
      relatedInvoices: response.related,
      paymentDate: this.invoiceComplementForm.value.payment_date,
      paymentAmount: this.payForm.value.amount,
      paymentMethod: this.complementPayments.find(
        payment => payment.id === this.payForm.value.payment_method_type
      )?.sat_code,
    });

    this.invoiceData = await firstValueFrom(this.store.createInvoiceComplement(payload));
    this.loading_msg = 'Finalizando y descargando el complemento de pago...';
    await this.download();
  }

  async download(): Promise<void> {
    const unitId = this.bill?.unit_id;
    if (!unitId) {
      throw new Error('El recibo no tiene una unidad asociada.');
    }

    const unitData: any = await firstValueFrom(this.store.getUnit(unitId));
    const floorResponse: any = await firstValueFrom(this.store.getFloor(unitData.floor_id));
    const floor = floorResponse?.data?.attributes ?? floorResponse?.attributes ?? floorResponse;
    const buildingId = floor?.building_id ?? floor?.building?.id ?? this.bill?.building?.id;
    if (!buildingId) {
      throw new Error('No fue posible identificar el edificio del recibo.');
    }
    const buildingData: any = await firstValueFrom(this.store.getBuilding(buildingId));
    const pdfData: any = await firstValueFrom(this.store.downloadComplement({
      bill: this.bill,
      dueDate: new Date(this.bill.due_date),
      unitData,
      buildingData,
      invoiceData: this.invoiceData,
      utilityData: this.profile,
    }));

    this.downloadFile(
      new Blob([new Uint8Array(pdfData.result.data)], { type: 'application/pdf' }),
      pdfData.filename
    );
    this.downloadFile(
      new Blob([this.invoiceData.cfdixml], { type: 'application/xml' }),
      `COMPLEMENTO_${this.invoiceData.id}.xml`
    );
    await firstValueFrom(this.store.updateInvoice(this.invoiceData.id, { pdf: pdfData.filename }));
  }

  private async refreshBillAfterPayment(): Promise<any> {
    let updatedBill = this.bill;
    for (let attempt = 0; attempt < 10; attempt++) {
      if (attempt > 0) {
        await firstValueFrom(timer(750));
      }
      try {
        updatedBill = await firstValueFrom(this.store.getBill(this.bill.id));
        if (updatedBill?.status || updatedBill?.paid_date) {
          break;
        }
      } catch (error) {
        if (attempt === 9) {
          throw error;
        }
      }
    }
    return updatedBill;
  }

  private downloadFile(blob: Blob, filename: string): void {
    const fileUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(fileUrl);
  }

  private errorDetail(error: any): string {
    const message = error?.error?.message
      ?? error?.error?.error
      ?? error?.message;
    return message ? ` ${message}` : '';
  }

  async processXML(xml: any) {
    this.parser = new xml2js.Parser({
      trim: true,            
      explicitArray: true,            
    });
    return await this.parser.parseStringPromise(xml).then(function (result: any) {
      return result;
    });
  }

  openModal(modalContent: TemplateRef<any>) {
    this.initForm();
    this.buildInvoiceComplementForm();
    this.complement.setValue(false);
    this.loading_msg = '';
    this.modalRef = this.modalService.open(modalContent, { backdrop: 'static', keyboard: false });
  }

  dismiss() {
    if (this.modalRef) {
      const modalRef = this.modalRef;
      this.modalRef = undefined;
      this.updateDismiss.emit();
      modalRef.dismiss();
    }
  }
}
